import { useState, useEffect } from 'react'

export const useServiceWorkerReady = () => {
  const [isReady, setIsReady] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const checkAndWaitForSW = async () => {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations()
        const rootScopeSW = registrations.find(
          reg => reg.scope === window.location.origin + '/' && reg.active && reg.active.state === 'activated'
        )

        if (rootScopeSW) {
          console.log('Service Worker already ready')
          setIsReady(true)
          setIsLoading(false)
          return
        }

        const registration = await navigator.serviceWorker.getRegistration('/')

        if (registration && registration.installing) {
          registration.installing.addEventListener('statechange', () => {
            if (registration.installing?.state === 'activated') {
              console.log('Service Worker activated')
              setIsReady(true)
              setIsLoading(false)
            }
          })
        } else {
          // Fallback
          setTimeout(() => {
            setIsReady(true)
            setIsLoading(false)
          }, 3000)
        }
      } catch (error) {
        console.error('Error checking Service Worker:', error)
        setIsReady(true) // Proceed anyway
        setIsLoading(false)
      }
    }

    checkAndWaitForSW()
  }, [])

  return { isReady, isLoading }
}
